var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMP4)?_c('video',{class:_vm.mainClass,attrs:{"width":"500","height":"280","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.imageSrc,"type":"video/mp4"}}),_vm._v("\r\n  Your browser does not support the video tag.\r\n")]):_c('img',{class:_vm.mainClass,attrs:{"src":_vm.imageSrc}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd87a694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameGif.vue
// module id = null
// module chunks = 